import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import { getSafelistSummaryMap } from 'services/safelists/getters';
import { SafelistMap } from 'shared/types/safelist';

import { SafelistNavContentProps } from './types';

const StyledSafelistNavContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledSafelistName = styled.span``;

const renderSafelistNames = (
  safelistLibraryGuids: SafelistNavContentProps['safelistLibraryGuids'],
  safelistMap: SafelistMap,
) => safelistLibraryGuids.map((guid) => (
  <StyledSafelistName key={guid}>
    {safelistMap[guid]?.name}
  </StyledSafelistName>
));

const SafelistNavContent = ({
  safelistLibraryGuids,
}: SafelistNavContentProps) => {
  const safelistMap = useSelector(getSafelistSummaryMap);

  return (
    <StyledSafelistNavContentContainer>
      {renderSafelistNames(safelistLibraryGuids, safelistMap)}
    </StyledSafelistNavContentContainer>
  );
};

export { SafelistNavContent };
